import React from "react";
import axios from "axios";
import "../../../assets/features.css";
import { BASE_URL, PILEHEIGHTS, HEADERS } from "../../../common/api";
import { DeleteButton, EditButton, AddButton } from "../../../assets/js/Button";
import { Modal, Form, Button } from "react-bootstrap";

class Pileheight extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pileheights: [],
      show: false,
      confirm: false,
      title: "",
      hight: "",
      isActive: false,
      id: "",
    };
    this._isMounted = false;
  }
  componentDidMount() {
    this._isMounted = true;
    this._isMounted &&
      axios.get(BASE_URL + PILEHEIGHTS).then((res) => {
        this.setState({ pileheights: res.data });
      });
    
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.show && !this.state.show) {
      this.setState({
        show: false,
        title: "",
        hight: "",
        id: "",
        isActive: false,
      });
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  showModal = () => {
    this.setState({ show: true });
  };

  showConfirmationModal = (event, id) => {
    this.setState({ confirm: true, id: id });
  };

  hideModal = () => {
    this.setState({ show: false, confirm: false });
  };

  get = (data) => {
    this.setState({
      title: data.title,
      hight: data.hight,
      isActive: data.isActive,
      id: data.id,
      show: true,
    });
  };

  delete = (id) => {
    const { pileheights } = this.state;
    axios.delete(BASE_URL + PILEHEIGHTS + id).then((res) => {
      const updatedData = pileheights.filter((material) => material.id !== id);
      this.setState({ pileheights: updatedData, confirm: false });
    });
  };

  addOrUpdate = (event) => {
    event.preventDefault();
    const { title, id, isActive, hight } = this.state;
    let data = {
      title: title,
      hight: hight,
      isActive: isActive,
    };

    if (id) {
      axios.put(BASE_URL + PILEHEIGHTS + id + "/", data, HEADERS).then((res) => {
        const { pileheights } = this.state;
        const index = pileheights.findIndex((material) => material.id === id);
        pileheights[index] = res.data;
        this.setState({ pileheights: pileheights, show: false });
      });
    } else {
      axios.post(BASE_URL + PILEHEIGHTS, data, HEADERS).then((res) => {
        this.setState({
          pileheights: [...this.state.pileheights, res.data],
          show: false,
        });
      });
    }
  };

  getTitle = () => {
    const { id } = this.state;
    if (id) {
      return <h3>Изменить</h3>;
    } else {
      return <h3>Добавить новый</h3>;
    }
  };

  render() {

    const { show, confirm, title, hight, isActive, id } = this.state;
    const { permission } = this.props;
    return (
      <>
        <Modal
          show={show}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.getTitle()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={(event) => this.addOrUpdate(event)}>
              <Form.Group className="mb-3" key={id}>
                
                <Form.Label>Наименование:</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={title}
                  onChange={this.handleChange}
                />
                <Form.Label>Высота ворса:</Form.Label>
                <Form.Control
                  type="text"
                  name="hight"
                  value={hight}
                  onChange={this.handleChange}
                />
                <Form.Label>Статус:</Form.Label>
                <Form.Control
                  as="select"
                  onChange={this.handleChange}
                  name="isActive"
                  value={isActive}
                >
                  <option value="true">Актив</option>
                  <option value="false">Пассив</option>
                </Form.Control>
              </Form.Group>
              <Button variant="primary" type="submit" onClick={this.showModal}>
                Сохранить
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
        <section id="tab-item-8">
          {permission && <AddButton onClick={() => this.showModal()} />}
          <table className="table table-hover">
            <thead className="thead-light">
              <tr>
                <th>Наименование:</th>
                <th>Высота ворса:</th>
                <th>Статус:</th>
                <th>Действия:</th>
              </tr>
            </thead>
            <tbody>
              {this.state.pileheights.map((material) => (
                <tr key={material.id}>
                  <td>{material.title}</td>
                  <td>{material.hight}</td>
                  <td>
                    <p
                      className={
                        material.isActive
                          ? "badge badge-light text-success"
                          : "badge badge-light text-danger"
                      }
                      role="alert"
                    >
                      {material.isActive ? "Актив" : "Пассив"}
                    </p>
                  </td>
                  <td>
                    {permission && (
                      <EditButton onClick={() => this.get(material)} />
                    )}
                    {permission && (
                      <DeleteButton
                        onClick={(event, id) =>
                          this.showConfirmationModal(event, material.id)
                        }
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <Modal
          show={confirm}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Удалить</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>Вы уверены, что хотите удалить эту информацию?</h5>
            <button
              className="btn btn-danger m-1"
              onClick={(event) => this.delete(id, event)}
            >
              Удалить
            </button>
            <button
              className="btn btn-light outline-secondary"
              onClick={() => {
                this.hideModal();
              }}
            >
              Назад
            </button>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default Pileheight;
